import './footer.css';

const Footer = () => {
    return(
        <footer className='text-center'>
            All Rights Reserved ©2022 - Tienda Libre - Design By : DayCampos
        </footer>
    );
}

export default Footer;